<div class="filter-modal-overlay" *ngIf="isVisible" (click)="onClose()" [class.closing]="isClosing">
  <div
    class="filter-modal"
    [class]="customClass"
    (click)="onModalRootClick($event)"
    [class.closing]="isClosing"
    [class.filter-modal--package-sort]="usePackageSortLayout"
  >
    <!-- Modal Header -->
    <div class="filter-modal-header">
      <h3 class="filter-modal-title">{{ header }}</h3>
      <button class="filter-modal-close" (click)="onClose()" aria-label="Close filter modal">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="filter-modal-content">
      <div class="filter-sort-location-wrap" *ngIf="sortPanelLocations.length">
        <div class="filter-sort-location-field">
          <label class="filter-sort-location-label">Location</label>
          <div class="filter-sort-panel-location">
            <div
              class="filter-sort-location-trigger"
              [class.open]="isSortPanelLocationDropdownOpen"
              [class.disabled]="isLoading"
              [attr.tabindex]="isLoading ? -1 : 0"
              role="button"
              [attr.aria-expanded]="isSortPanelLocationDropdownOpen"
              aria-label="Select location"
              (click)="toggleSortPanelLocationDropdown($event)"
            >
              <div class="filter-sort-location-selected">
                <span
                  class="filter-sort-location-value"
                  [class.placeholder]="!sortPanelSelectedLocationId"
                  >{{ getSortPanelSelectedLocationLabel() }}</span
                >
                <svg
                  class="filter-sort-location-arrow"
                  [class.rotated]="isSortPanelLocationDropdownOpen"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                class="filter-sort-location-menu"
                *ngIf="isSortPanelLocationDropdownOpen"
                (mousedown)="$event.preventDefault()"
              >
                <div
                  *ngFor="let loc of sortPanelLocations"
                  class="filter-sort-location-option"
                  [class.selected]="loc.id === sortPanelSelectedLocationId"
                  (click)="selectSortPanelLocation(loc, $event)"
                >
                  {{ loc.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-loading" *ngIf="!isPanelReady">{{ loadingLabel }}</div>
      <ng-template #filterCategoryBlock let-category>
        <h4 class="filter-category-title" *ngIf="!shouldHideCategoryTitle(category)">
          {{ category.name }}
        </h4>

        <!-- Checkbox Options -->
        <div class="filter-options" *ngIf="!category.type || category.type === 'checkbox'">
          <label class="filter-option" *ngFor="let option of category.options">
            <input
              type="checkbox"
              [checked]="option.selected"
              (change)="onOptionChange(category.id, option.id)"
              class="filter-checkbox"
            />
            <span class="filter-option-label">{{ option.label }}</span>
          </label>
        </div>

        <!-- Multi-select dropdown (Create Discount Location pattern) -->
        <div class="filter-multi-dropdown-wrapper" *ngIf="category.type === 'multi-dropdown'">
          <app-checkbox-multi-dropdown
            [options]="getMultiDropdownOptions(category)"
            [selectedIds]="getMultiDropdownSelectedIds(category)"
            appearance="input"
            [checkboxSize]="multiDropdownCheckboxSize"
            [showFooter]="false"
            [showAllOption]="false"
            [fixedOverlay]="true"
            [footerAction]="multiDropdownClearAction"
            [placeholder]="getMultiDropdownPlaceholder(category)"
            [ariaLabel]="category.name"
            (selectedIdsChange)="onMultiDropdownSelectedIdsChange(category.id, $event)"
            (footerActionClick)="onMultiDropdownClear(category.id)"
          ></app-checkbox-multi-dropdown>
        </div>

        <!-- Date Range (start/end) — always visible for a `date-range` category, unlike the
             custom range below which only appears once a "Custom" preset is picked. -->
        <div class="custom-date-range" *ngIf="shouldShowDateRange(category)">
          <div class="custom-date-range-grid">
            <div class="date-field">
              <label class="date-field-label">{{
                customRangeConfig?.startLabel || 'Start Date'
              }}</label>
              <app-custom-date-picker
                [ngModel]="customRangeConfig?.startDate || null"
                [ngModelOptions]="{ standalone: true }"
                [placeholder]="customRangeConfig?.startPlaceholder || 'Start date'"
                mode="date"
                [showTime]="false"
                [allowPastDates]="true"
                [maxDate]="customRangeConfig?.maxDate || null"
                [fixedOverlay]="true"
                (ngModelChange)="onCustomRangeInput('start', $event)"
              ></app-custom-date-picker>
            </div>
            <div class="date-field">
              <label class="date-field-label">{{
                customRangeConfig?.endLabel || 'End Date'
              }}</label>
              <app-custom-date-picker
                [ngModel]="customRangeConfig?.endDate || null"
                [ngModelOptions]="{ standalone: true }"
                [placeholder]="customRangeConfig?.endPlaceholder || 'End date'"
                mode="date"
                [showTime]="false"
                [allowPastDates]="true"
                [minDate]="customRangeConfig?.startDate || null"
                [maxDate]="customRangeConfig?.maxDate || null"
                [fixedOverlay]="true"
                dropdownAlign="right"
                (ngModelChange)="onCustomRangeInput('end', $event)"
              ></app-custom-date-picker>
            </div>
          </div>
        </div>

        <!-- Amount Range (min/max currency) -->
        <div class="filter-amount-range" *ngIf="shouldShowAmountRange(category)">
          <div class="filter-amount-range-grid">
            <div class="amount-field">
              <label class="amount-field-label">{{
                amountRangeConfig?.minLabel || 'Min Amount'
              }}</label>
              <app-currency-action-input
                [value]="amountRangeConfig?.minAmount ?? null"
                [showAction]="false"
                [allowDecimal]="true"
                [allowNull]="true"
                size="compact"
                [placeholder]="amountRangeConfig?.minPlaceholder || '0.00'"
                (valueChange)="onAmountRangeInput('min', $event)"
              ></app-currency-action-input>
            </div>
            <div class="amount-field">
              <label class="amount-field-label">{{
                amountRangeConfig?.maxLabel || 'Max Amount'
              }}</label>
              <app-currency-action-input
                [value]="amountRangeConfig?.maxAmount ?? null"
                [showAction]="false"
                [allowDecimal]="true"
                [allowNull]="true"
                size="compact"
                [placeholder]="amountRangeConfig?.maxPlaceholder || '0.00'"
                (valueChange)="onAmountRangeInput('max', $event)"
              ></app-currency-action-input>
            </div>
          </div>
        </div>

        <!-- Radio Button Options -->
        <div class="filter-options filter-options--sort" *ngIf="category.type === 'radio'">
          <label
            class="filter-option"
            [class.filter-option--custom-sort]="isCustomSortOption(option)"
            *ngFor="let option of category.options"
          >
            <input
              type="radio"
              [name]="category.id"
              [checked]="option.selected"
              (change)="onOptionChange(category.id, option.id)"
              class="filter-radio"
            />
            <ng-container
              *ngIf="
                !isCustomSortOption(option) || renameEditingOptionValue !== option.value;
                else filterCustomSortRenameTpl
              "
            >
              <span class="filter-option-label">{{ option.label }}</span>
            </ng-container>
            <ng-template #filterCustomSortRenameTpl>
              <div class="filter-custom-sort-rename-editor" (click)="$event.stopPropagation()">
                <div class="filter-custom-sort-rename-row">
                  <input
                    type="text"
                    class="filter-custom-sort-rename-input"
                    [(ngModel)]="renameDraft"
                    (ngModelChange)="renameInlineError = ''"
                    (keydown.enter)="commitCustomSortRename(option, $event)"
                    [attr.aria-invalid]="renameInlineError ? 'true' : null"
                    [attr.aria-label]="'Custom sort name'"
                  />
                  <button
                    type="button"
                    class="filter-custom-sort-rename-save"
                    (click)="commitCustomSortRename(option, $event)"
                    aria-label="Save custom sort name"
                  >
                    Save
                  </button>
                </div>
                <span class="filter-custom-sort-rename-error" *ngIf="renameInlineError">{{
                  renameInlineError
                }}</span>
              </div>
            </ng-template>
            <button
              *ngIf="triggerMostUsedOnOptionValue && option.value === triggerMostUsedOnOptionValue"
              type="button"
              class="filter-custom-drag-add"
              aria-label="Open drag and drop arrangement"
              [disabled]="isSortPanelLocationMissing"
              (click)="onCustomDragQuickAction($event)"
            >
              +
            </button>
            <div class="filter-custom-sort-actions" *ngIf="isCustomSortOption(option)">
              <button
                type="button"
                class="filter-custom-sort-kebab"
                aria-label="Custom sort actions"
                (click)="onCustomSortMenuToggle(option.value, $event)"
              >
                ⋮
              </button>
              <div class="filter-custom-sort-menu" *ngIf="openCustomSortMenuValue === option.value">
                <button
                  type="button"
                  class="filter-custom-sort-item"
                  (click)="onCustomSortRename(option, $event)"
                >
                  <span>Rename</span>
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                </button>
                <button
                  type="button"
                  class="filter-custom-sort-item filter-custom-sort-item--danger"
                  (click)="onCustomSortDelete(option, $event)"
                >
                  <span>Delete</span>
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                    <path d="M10 11v6" />
                    <path d="M14 11v6" />
                    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                  </svg>
                </button>
              </div>
            </div>
          </label>
        </div>

        <!-- Custom Date Range for Radio Buttons -->
        <div
          class="custom-date-range"
          *ngIf="category.type === 'radio' && shouldShowCustomRange(category)"
        >
          <div class="custom-date-range-grid">
            <div class="date-field">
              <label class="date-field-label">{{
                customRangeConfig?.startLabel || 'Start Date'
              }}</label>
              <mat-datepicker
                [ngModel]="customRangeConfig?.startDate || null"
                (ngModelChange)="onCustomRangeInput('start', $event)"
              >
              </mat-datepicker>
            </div>
            <div class="date-field">
              <label class="date-field-label">{{
                customRangeConfig?.endLabel || 'End Date'
              }}</label>
              <mat-datepicker
                [ngModel]="customRangeConfig?.endDate || null"
                (ngModelChange)="onCustomRangeInput('end', $event)"
              >
              </mat-datepicker>
            </div>
          </div>
        </div>

        <!-- Dropdown Options -->
        <div class="filter-dropdown-wrapper" *ngIf="category.type === 'dropdown'">
          <div class="custom-filter-dropdown" [attr.data-filter-dropdown-id]="category.id">
            <div
              class="dropdown-selected"
              [class.open]="isDropdownOpen(category.id)"
              (click)="toggleDropdown(category.id, $event)"
            >
              <span
                class="selected-value"
                [class.placeholder]="!getSelectedDropdownValue(category)"
              >
                {{ getSelectedDropdownLabel(category) }}
              </span>
              <svg
                class="dropdown-arrow"
                [class.rotated]="isDropdownOpen(category.id)"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.28 7.38L10 12.1L14.72 7.38"
                  stroke="#15172E"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              class="dropdown-menu filter-modal-dropdown-menu"
              [class.show]="isDropdownOpen(category.id)"
              [class.filter-modal-dropdown-menu--fixed-overlay]="isDropdownOpen(category.id)"
              [class.filter-modal-dropdown-menu--is-positioned]="
                dropdownOverlayReady && isDropdownOpen(category.id)
              "
            >
              <div
                *ngFor="let option of category.options"
                class="dropdown-option"
                [class.selected]="option.selected"
                (click)="selectDropdownOption(category.id, option.value, option.label)"
              >
                {{ option.label }}
              </div>
            </div>
          </div>

          <div class="custom-date-range" *ngIf="shouldShowCustomRange(category)">
            <div class="custom-date-range-grid">
              <div class="date-field">
                <label class="date-field-label">{{
                  customRangeConfig?.startLabel || 'From'
                }}</label>
                <mat-datepicker> </mat-datepicker>
                <input
                  matInput
                  [ngModel]="customRangeConfig?.startDate || null"
                  (ngModelChange)="onCustomRangeInput('start', $event)"
                  placeholder="mm/dd/yyyy"
                />
              </div>
              <div class="date-field">
                <label class="date-field-label">{{ customRangeConfig?.endLabel || 'To' }}</label>
                <mat-datepicker> </mat-datepicker>
                <input
                  matInput
                  [ngModel]="customRangeConfig?.endDate || null"
                  (ngModelChange)="onCustomRangeInput('end', $event)"
                  placeholder="mm/dd/yyyy"
                />
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <div class="filter-categories" *ngIf="isPanelReady && categories.length > 0">
        <div *ngIf="usePackageSortLayout" class="filter-package-sort-top">
          <div class="filter-package-sort-top__left" *ngIf="!carWashCategory">
            <h4 class="filter-category-title filter-category-title--top">Sort By</h4>
          </div>
          <div class="filter-package-sort-top__car-wash" *ngIf="carWashCategory as cw">
            <div class="filter-category">
              <ng-container
                *ngTemplateOutlet="filterCategoryBlock; context: { $implicit: cw }"
              ></ng-container>
            </div>
          </div>
          <div
            class="filter-package-sort-top__drag"
            *ngIf="showMostUsedServices && carWashCategory"
          >
            <button
              type="button"
              class="filter-most-used-btn filter-most-used-btn--figma"
              [disabled]="isSortPanelLocationMissing"
              (click)="onMostUsedServicesClick()"
            >
              {{ mostUsedServicesButtonText }}
            </button>
          </div>
        </div>
        <div class="filter-category" *ngFor="let category of mainCategoriesForLayout">
          <ng-container
            *ngTemplateOutlet="filterCategoryBlock; context: { $implicit: category }"
          ></ng-container>
        </div>
      </div>

      <div class="filter-empty" *ngIf="isPanelReady && categories.length === 0">
        <p>No filter options available.</p>
      </div>

      <div
        class="filter-most-used-wrap"
        *ngIf="isPanelReady && showMostUsedServices && (!usePackageSortLayout || !carWashCategory)"
      >
        <button
          type="button"
          class="filter-most-used-btn filter-most-used-btn--figma"
          [disabled]="isSortPanelLocationMissing"
          (click)="onMostUsedServicesDefaultsClick()"
        >
          {{ mostUsedServicesButtonText }}
        </button>
      </div>

      <!-- Mounted as soon as the panel opens so its fetch runs alongside the sort options.
           Hidden rather than *ngIf'd while loading: *ngIf would defer the fetch, which is
           exactly the staged load CWS-598 reports. -->
      <app-rewash-settings
        *ngIf="showRewashSettings"
        [class.filter-modal__deferred]="!isPanelReady"
        [isActive]="isVisible"
        (loadingChange)="onRewashLoadingChange($event)"
      >
      </app-rewash-settings>

      <app-family-plan-settings
        *ngIf="showFamilyPlanSettings"
        [class.filter-modal__deferred]="!isPanelReady"
        [isActive]="isVisible"
        [locationId]="sortPanelSelectedLocationId"
        (loadingChange)="onFamilyLoadingChange($event)"
        (dirtyChange)="onFamilyDirtyChange($event)"
      >
      </app-family-plan-settings>
    </div>

    <!-- Modal Footer -->
    <app-modal-footer-actions
      footerClass="modal-footer"
      [secondaryText]="secondaryButtonText"
      [primaryText]="primaryButtonText"
      [secondaryDisabled]="
        !isPanelReady ||
        (sortPanelLocations.length ? isSortPanelLocationMissing : getSelectedCount() === 0)
      "
      [primaryDisabled]="isApplyDisabled"
      [cancelDesktopOnly]="true"
      (secondaryClick)="onClear()"
      (cancelClick)="onClose()"
      (primaryClick)="onApply()"
    />
  </div>
</div>
